import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared';
import { Core2Config } from '../../shared';
import { AppletAuditTrailContainer } from '../../../../../../models';

@Injectable({
  providedIn: 'root'
})
export class AppletAuditTrailService extends BaseApiTemplateService<AppletAuditTrailContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-audit-trail';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-audit-trail';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-audit-trail';
    this.httpClient = http;
  }
}